
define('text!templates/reports_button.html',[],function () { return '<li class="pl-reports">\n    <a href="javascript://" data-post-id="<%=postId%>" rel="nofollow">Пожаловаться</a>\n</li>';});

